import { RootRoute } from "#src/routes/root";
import { RoutePath } from "#src/utils/route";

export const DataToolsRoutePath = RootRoute.concat(
  new RoutePath({
    path: "/data-tools",
    title: "Data Tools",
    isPresentational: true,
  })
);
